import { render, staticRenderFns } from "./boardAllRight.vue?vue&type=template&id=57a75776&scoped=true&"
import script from "./boardAllRight.vue?vue&type=script&lang=js&"
export * from "./boardAllRight.vue?vue&type=script&lang=js&"
import style0 from "./boardAllRight.vue?vue&type=style&index=0&id=57a75776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a75776",
  null
  
)

export default component.exports